import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { saveMapping } from "utils/collegeDocumentService";
import { withSequentialSortOrder } from "./mappingFieldFactory";
import { FILES_QUERY_KEY, MAPPING_QUERY_KEY } from "./documentLibraryQueryKeys";
import { libraryErrorMessage } from "./libraryErrorMessage";

/** Persists the current field list for a file. Invalidates the file list too, since a save
 * changes `mappedFieldCount` shown back in the library table. */
export const useMappingMutations = (fileId, fields) => {
  const queryClient = useQueryClient();

  const saveMutation = useMutation({
    mutationFn: () => saveMapping(fileId, withSequentialSortOrder(fields)),
    onSuccess: () => {
      toast.success("Mapping saved");
      queryClient.invalidateQueries({ queryKey: [MAPPING_QUERY_KEY, fileId] });
      queryClient.invalidateQueries({ queryKey: [FILES_QUERY_KEY] });
    },
    onError: (error) => toast.error(libraryErrorMessage(error, "Could not save the mapping")),
  });

  return { saveMutation };
};
